import React from "react";
import { AHIcon, AHText, TouchableBox, useLayoutContext } from "arkh";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { SignalOpenedByEmployeeButton_signal$key } from "./__generated__/SignalOpenedByEmployeeButton_signal.graphql";

export function SignalOpenedByEmployeeButton(props: {
  onPress: () => void;
  signal: SignalOpenedByEmployeeButton_signal$key;
}) {
  const layout = useLayoutContext();

  const signal = useFragment(
    graphql`
      fragment SignalOpenedByEmployeeButton_signal on Signal {
        id
        employeeReceiverReceiptsCount
        store {
          id
          employeeCount
        }
      }
    `,
    props.signal
  );

  return (
    <TouchableBox
      style={{
        borderWidth: 1,
        height: layout.circle.smallMedium,
        borderRadius: layout.circle.smallMedium / 2,
        flexDirection: "row",
        alignItems: "center",
      }}
      spaceHorizontal="small"
      borderColor="border-primary"
      disabled={signal.store.employeeCount === 0}
      onPress={() => props.onPress()}
    >
      <AHIcon type="eye" color="text-secondary" spaceRight="small" />
      <AHText type="subtitle" color="text-secondary" selectable={false}>
        <FormattedMessage
          defaultMessage="{seenCount}<washed>/{totalCount}</washed> Employees"
          description="Signal Detail Screen Employees Unseen Button"
          values={{
            seenCount: signal.employeeReceiverReceiptsCount,
            totalCount: signal.store.employeeCount,
            washed: (chunks) => (
              <AHText type="subtitle" selectable={false} color="text-washed">
                {chunks}
              </AHText>
            ),
          }}
        />
      </AHText>
    </TouchableBox>
  );
}
